import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const useScrollToTop = () => {
	const history = useHistory();

	useEffect(() => {
		const unregister = history.listen((_location, action) => {
			action === "PUSH" && window.scrollTo(0, 0);
		});

		return () => {
			unregister();
		}
	}, []);
}

export default useScrollToTop;